import { React, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import cityLogo from "../Images/logo.webp";

function ContentPopup() {
  const [show, setShow] = useState(true);

  const handleModal = (e) => {
    setShow(!show);
  };

  return (
    <div>
      <div>
        <Modal
          show={show}
          onHide={handleModal}
          id="modelContent"
          size="xl"
          centered
        >
          <Button id="pop-close1" onClick={handleModal}>
            &times;
          </Button>
          <Modal.Header id="header">
            <img id="popImg" src={cityLogo} alt="img-responsive" />
          </Modal.Header>
          <div className="model-body">
            <ul className="llist">
              <li key="1">
                Expect an email within 5 business days from{" "}
                <a href={"mailto:" + process.env.REACT_APP_NO_REPLY}>
                  <strong>{process.env.REACT_APP_NO_REPLY}</strong>
                </a>{" "}
                or
                <br />
                <a href={"mailto:" + process.env.REACT_APP_DESC_EMAIL}>
                  <strong>{process.env.REACT_APP_DESC_EMAIL}</strong>
                </a>{" "}
                we suggest adding these email addresses to your SAFE SENDER list in your email settings.
              </li>
              <li key="2">
                You will need to click that link to finalize your order and
                select your preferred delivery method.
              </li>
              <li key="3">
                You will need to finalize your order by following the
                instructions in that email from <br />
                <a
                  className="fw-medium"
                  href={"mailto:" + process.env.REACT_APP_THANKPOPUP_EMAIL}
                >
                  {process.env.REACT_APP_THANKPOPUP_EMAIL}
                </a>
              </li>
              <br />
              <p>
                <b>
                  PLEASE NOTE: You only have 30 days to activate your card.
                  Check your inbox, junk and spam and contact our customer
                  service line if you haven't received the email within the
                  week.
                </b>
              </p>
            </ul>
          </div>
        </Modal>
      </div>
    </div>
  );
}

export default ContentPopup;
